var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgWaves01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 400",
    width: 900,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 400,
    fill: "#fed9d5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "55.6%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#7e1925",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#7e1925",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "55.6%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#7e1925",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#ab5b59",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "55.6%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#d69994",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#ab5b59",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "55.6%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#d69994",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#fed9d5",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "44.4%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#7e1925",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#7e1925",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "0%",
    x2: "44.4%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#ab5b59",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#7e1925",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "0%",
    x2: "44.4%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#ab5b59",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#d69994",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "0%",
    x2: "44.4%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#fed9d5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#d69994",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 400C-20.5 354.7 -41.1 309.5 -69 302.2C-96.9 295 -132.1 325.7 -154 319.8C-175.9 314 -184.5 271.4 -195.2 244.7C-205.8 218 -218.5 207 -251.7 200.8C-285 194.5 -338.8 193 -360.4 173.6C-381.9 154.2 -371.2 116.9 -372.4 85C-373.6 53.1 -386.8 26.6 -400 0L0 0Z",
    fill: "#eab9b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 300C-15.4 266.1 -30.8 232.1 -51.7 226.7C-72.7 221.2 -99.1 244.3 -115.5 239.9C-132 235.5 -138.4 203.6 -146.4 183.5C-154.3 163.5 -163.9 155.3 -188.8 150.6C-213.8 145.9 -254.1 144.7 -270.3 130.2C-286.5 115.6 -278.4 87.7 -279.3 63.8C-280.2 39.8 -290.1 19.9 -300 0L0 0Z",
    fill: "#c17a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 200C-10.3 177.4 -20.5 154.7 -34.5 151.1C-48.4 147.5 -66.1 162.9 -77 159.9C-88 157 -92.3 135.7 -97.6 122.4C-102.9 109 -109.2 103.5 -125.9 100.4C-142.5 97.3 -169.4 96.5 -180.2 86.8C-191 77.1 -185.6 58.5 -186.2 42.5C-186.8 26.6 -193.4 13.3 -200 0L0 0Z",
    fill: "#953c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 100C-5.1 88.7 -10.3 77.4 -17.2 75.6C-24.2 73.7 -33 81.4 -38.5 80C-44 78.5 -46.1 67.9 -48.8 61.2C-51.4 54.5 -54.6 51.8 -62.9 50.2C-71.3 48.6 -84.7 48.2 -90.1 43.4C-95.5 38.5 -92.8 29.2 -93.1 21.3C-93.4 13.3 -96.7 6.6 -100 0L0 0Z",
    fill: "#7e1925"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -400C29.2 -389.4 58.3 -378.9 83 -363.6C107.7 -348.4 127.9 -328.6 151 -313.5C174.1 -298.5 200.1 -288.3 213.2 -267.4C226.3 -246.5 226.5 -214.9 249.4 -198.9C272.3 -182.9 318.1 -182.5 346 -166.6C373.9 -150.7 383.9 -119.4 390 -89C396 -58.7 398 -29.3 400 0L0 0Z",
    fill: "#eab9b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -300C21.9 -292.1 43.7 -284.1 62.3 -272.7C80.8 -261.3 95.9 -246.4 113.2 -235.2C130.6 -223.9 150.1 -216.2 159.9 -200.5C169.7 -184.9 169.9 -161.2 187.1 -149.2C204.3 -137.2 238.6 -136.9 259.5 -125C280.4 -113 288 -89.5 292.5 -66.8C297 -44 298.5 -22 300 0L0 0Z",
    fill: "#c17a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -200C14.6 -194.7 29.2 -189.4 41.5 -181.8C53.8 -174.2 63.9 -164.3 75.5 -156.8C87.1 -149.3 100.1 -144.1 106.6 -133.7C113.2 -123.2 113.2 -107.4 124.7 -99.4C136.2 -91.4 159 -91.2 173 -83.3C186.9 -75.4 192 -59.7 195 -44.5C198 -29.3 199 -14.7 200 0L0 0Z",
    fill: "#953c3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -100C7.3 -97.4 14.6 -94.7 20.8 -90.9C26.9 -87.1 32 -82.1 37.7 -78.4C43.5 -74.6 50 -72.1 53.3 -66.8C56.6 -61.6 56.6 -53.7 62.4 -49.7C68.1 -45.7 79.5 -45.6 86.5 -41.7C93.5 -37.7 96 -29.8 97.5 -22.3C99 -14.7 99.5 -7.3 100 0L0 0Z",
    fill: "#7e1925"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaves01);
export default __webpack_public_path__ + "static/media/bg-waves01.f3073473fbf0abadd970032a9656d35c.svg";
export { ForwardRef as ReactComponent };